import { HugeiconsIcon } from "@hugeicons/react";
import { SmartPhone01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Avatar } from "shared/components/Avatar";
import { cx } from "shared/utils";

interface AddressChipProps {
  address: string;
  name?: string;
  /** Chips inside an outgoing bubble take the design's pink ground. */
  tinted?: boolean;
}

const hasLetters = (value: string) => /\p{L}/u.test(value);

export const AddressChip = ({ address, name, tinted }: AddressChipProps) => {
  const label = name || address;

  return (
    <span
      className={cx(
        "flex min-w-0 shrink items-center gap-2 rounded-[50px] border border-dashed border-alpha-100 py-1.5 pl-1.5 pr-2",
        tinted ? "bg-primary-50" : "bg-background-900"
      )}
    >
      {hasLetters(label) ? (
        <Avatar name={label} size={20} className="text-[8px] font-bold" />
      ) : (
        <span className="grid size-5 shrink-0 place-items-center rounded-full bg-alpha-80">
          <HugeiconsIcon
            icon={SmartPhone01Icon}
            size={12}
            className="text-content-500"
          />
        </span>
      )}
      <span className="truncate text-xs font-medium text-content-1000">
        {address}
      </span>
    </span>
  );
};
